import React, { useEffect, useState } from 'react';
import { Layers } from 'lucide-react';
import api from '../../api/client';

export default function Variants() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get('/products').then(r => setProducts(r.data)); }, []);

  return (
    <div>
      <h1 style={{ fontFamily:"'Barlow Condensed'",fontSize: 'var(--font-size-title)',fontWeight:'800',letterSpacing:'2px',marginBottom:'8px' }}>VARIANTI & TAGLIE</h1>
      <p style={{ color:'var(--text-dim)',fontSize:'var(--font-size-sm)',marginBottom:'24px' }}>Panoramica varianti per prodotto — gestisci le taglie attive</p>
      {products.map(p => (
        <div key={p.id} style={{ background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:'10px',padding:'16px',marginBottom:'10px' }}>
          <div style={{ display:'flex',justifyContent:'space-between',marginBottom:'10px' }}>
            <div><div style={{ fontWeight:'700' }}>{p.nome}</div><div style={{ fontSize:'var(--font-size-xs)',color:'var(--text-dim)' }}>{p.sku_base}</div></div>
            <div style={{ fontSize:'var(--font-size-xs)',color:'var(--text-dim)' }}>{p.category?.nome}</div>
          </div>
          <div style={{ display:'flex',flexWrap:'wrap',gap:'8px' }}>
            {p.variants?.map(v => (
              <div key={v.id} style={{ background: v.attiva ? 'var(--bg-input)' : 'var(--bg)', border:`1px solid ${v.attiva ? 'var(--border2)' : 'var(--bg-input)'}`, borderRadius:'8px', padding:'8px 14px', opacity: v.attiva ? 1 : 0.4 }}>
                <div style={{ fontSize:'var(--font-size-xs)',color:'var(--text-dim)',fontWeight:'700' }}>{v.taglia}</div>
                <div style={{ fontSize:'var(--font-size-sm)',fontWeight:'800',color: v.attiva ? 'var(--text)' : 'var(--text-dim)' }}>{v.sku}</div>
                <div style={{ fontSize:'var(--font-size-xs)',color: v.attiva ? '#22C55E' : 'var(--text-dim)',marginTop:'2px' }}>{v.attiva ? 'ATTIVA' : 'DISATTIVA'}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
